<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="类型名称">
              <a-input v-model="queryParam.name" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="类型代码">
              <a-input v-model="queryParam.code" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button type="dashed" v-if="config.hasAlert" @click="tableOption">{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
      :rowSelection="options.rowSelection">
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical"/>
        <a @click="handleDel(record)">删除</a>
      </span>
    </s-table>

    <a-modal title="编辑" style="top: 20px;" :width="560" v-model="visible" @ok="handleOk" :confirmLoading="confirmLoading">
      <a-form :form="form">
        <a-form-item label="类型名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.name"
            placeholder="类型名称"
            v-decorator="['name',
            { initialValue: mdl.name, rules: [{ required: true, message: '请输入类型名称'}]}]" />
        </a-form-item>

        <a-form-item label="类型代码" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.code"
            placeholder="类型代码"
            v-decorator="['code',
            { initialValue: mdl.code, rules: [{ required: true, message: '请输入类型代码'}]}]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { formatDate } from '@/utils/date'
import { codeTypeUpdate, codeTypeSave, codeTypeDelete, codeTypePage } from '@/api/sys'

export default {
  name: 'codeType',
  components: {
    STable
  },
  data () {
    return {
      pageSizeOptionsList:['10'],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '字典类型名称',
          dataIndex: 'name'
        },
        {
          title: '字典类型代码',
          dataIndex: 'code'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          customRender: (text) => {
              let date = new Date(text)
              return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return codeTypePage(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },

      selectedRowKeys: [],
      edRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created () {
    this.tableOption()
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit (record) {
      this.mdl = Object.assign({}, record)
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleAdd () {
      this.mdl = {}
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleOk () {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            codeTypeUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
          } else {
            codeTypeSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },
    handleDel (record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk () {
          return codeTypeDelete({ 'ids': record.id })
            .then(res => {
              if(res.code ==='0') {
                nthis.$refs.table.refresh()
              }
            }).catch((e) => {
              console.log(e)
            }).finally(() => {
            })
        },
        onCancel () {
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>
